import { Navigate, useSearchParams } from "react-router-dom";

// Old /compare?a=A&b=B route — comparison now lives inline on the
// SymbolDetail page (see CompareDrawer). Redirect to A's detail page
// with ?compare=B so the drawer pre-opens.
export default function Compare() {
  const [params] = useSearchParams();
  const a = (params.get("a") ?? "").trim().toUpperCase();
  const b = (params.get("b") ?? "").trim().toUpperCase();
  if (!a) return <Navigate to="/" replace />;
  const target = b ? `/s/${encodeURIComponent(a)}?compare=${encodeURIComponent(b)}` : `/s/${encodeURIComponent(a)}`;
  return <Navigate to={target} replace />;
}
